import { IAnalyticsEvent } from '@verv-inc/js-toolkit';

export enum FB_EVENT_CONTENT_TYPE {
	PRODUCT = 'product',
}
interface FacebookEventAddToCardParameters {
	value: number;
	currency: string;
	contentName: string;
	contentType: FB_EVENT_CONTENT_TYPE; // Required for Dynamic Product Ads
	contentIDs: string[]; // Required for Dynamic Product Ads
}

export const FacebookEvent = {
	addToCard: (parameters: FacebookEventAddToCardParameters): IAnalyticsEvent => {
		return {
			name: 'AddToCart',
			info: {
				value: parameters.value,
				currency: parameters.currency,
				content_name: parameters.contentName,
				content_type: parameters.contentType,
				content_ids: parameters.contentIDs,
			},
		};
	},
};
